module.exports = "/images/LTRLBackground_tablet.png?bd198fe678b73b8349af3ac106f91191";